import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { RANK_DISPLAY, rankTierName } from './RankBadge';
import '../css/RankProgressBar.css';

function RankProgressBar({ rankProgress, compact = false, showPracticeNote = false }) {
    const { t } = useTranslation();
    if (!rankProgress) return null;

    const { rankTier, rankStars, starsRequired } = rankProgress;
    const display = RANK_DISPLAY[rankTier] || RANK_DISPLAY['bronze_3'];
    const tierName = rankTierName(t, rankTier);
    const fillPercent = starsRequired > 0
        ? Math.min(100, (rankStars / starsRequired) * 100)
        : 100;

    if (compact) {
        return (
            <div className="rank-progress-compact">
                <i className={`fas ${display.icon}`} style={{ color: display.color }} />
                <span className="rank-progress-compact-name" style={{ color: display.color }}>
                    {tierName}
                </span>
                <div className="rank-progress-stars-compact">
                    {starsRequired > 0 ? (
                        [...Array(starsRequired)].map((_, i) => (
                            <i
                                key={i}
                                className={`fa fa-star ${i < rankStars ? 'filled' : 'empty'}`}
                            />
                        ))
                    ) : (
                        <span className="rank-progress-star-count">{rankStars}</span>
                    )}
                </div>
                {showPracticeNote && (
                    <span className="rank-progress-practice-note-compact">{t('rank.notRanked')}</span>
                )}
            </div>
        );
    }

    return (
        <div className="rank-progress-bar">
            <div className="rank-progress-tier">
                <i className={`fas ${display.icon}`} style={{ color: display.color }} />
                <span className="rank-progress-name" style={{ color: display.color }}>
                    {tierName}
                </span>
            </div>
            <div className="rank-progress-track">
                <div
                    className="rank-progress-fill"
                    style={{
                        width: `${fillPercent}%`,
                        background: `linear-gradient(90deg, ${display.color}cc, ${display.color})`,
                    }}
                />
            </div>
            <span className="rank-progress-count">
                {starsRequired > 0 ? `${rankStars}/${starsRequired}` : rankStars}
                <i className="fa fa-star rank-star-icon" />
            </span>
            {showPracticeNote && (
                <span className="rank-progress-practice-note">{t('rank.playRankedForStars')}</span>
            )}
        </div>
    );
}

export default RankProgressBar;
